import { v4 as uuidv4 } from 'uuid';
import mock from '../config/mock';

mock.onGet('/api/appointments').reply(200, {

    appointments: [
        {
            id: uuidv4(),
            slot: '3',
            agent: 'agent001',
            startdate: '2020-01-01 00:00:00',
            bookingdate: '2020-01-01 00:00:00',
        },
        {
            id: uuidv4(),
            slot: '5',
            agent: 'agent002',
            bookingdate: '2020-01-01 00:00:00',
        },
        {
            id: uuidv4(),
            slot: '1',
            agent: 'agent003',
            bookingdate: '2020-01-01 00:00:00',
        },
    ]
});